import { CheckboxMultipleMarkedCircleOutlineIcon } from './CheckboxMultipleMarkedCircleOutlineIcon';

/**
 * author: Simran
 * id 5158D0E3-0E77-4CC3-A9A4-727825812D00
 * name checkbox-multiple-marked-circle-outline
 * version: 1.6.50
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/checkbox-multiple-marked-circle-outline.svg
 * tags
 * - Form 
 */
export const CheckboxesMarkedCircleOutlineIcon = CheckboxMultipleMarkedCircleOutlineIcon;
export default CheckboxesMarkedCircleOutlineIcon